import React from 'react';
import InputMask from 'react-input-mask';

export function MaskedPartNumberInput(props) {
  return (
    <InputMask
      mask="999-99999"
      id={props.id}
      onChange={props.onChange}
      value={props.value}
      disabled={props.disabled}
      className={props.className}
      placeholder={props.placeholder}
      autoFocus
    />
  );
}
